<template>
    <div class="result result-page">
        <div class="row">
            <div class="col-md-3">
                <div class="result-thumbnail">
                    <a :href="fields.url" target="_blank">
                        <figure>
                            <img :src="previewThumbnail" alt="" loading="lazy">
                        </figure>
                    </a>
                </div>
            </div>
            <div class="col-md-7">
                <div class="result-info">
                    <div class="result-title" v-html="fields.title">

                    </div>
                    <p class="result-description" v-html="fields.description">

                    </p>

                    <a :href="fields.url" class="result-url">
                        {{fields.url}}
                    </a>
                </div>
            </div>
            <div class="col-md-2">
                <div class="result-actions">

                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "DocumentResult",
        props: ['result'],
        data: function () {
            return {
                baseUrl: process.env.VUE_APP_SI_BASE,

                id: null
            }
        },
        computed: {
            fields() {
                return this.result.fields;
            },
            previewThumbnail() {

            }
        }
    }
</script>
<style lang="less">
    .result-page {
        .result-url {
            font-size: 13px;
        }
    }
</style>
